import React, { useEffect, useRef, useState } from 'react';
import { Outlet, Link } from "react-router-dom";

import moment from 'moment';

const CustomSlider1 = ({ className, banners, interval = 3000, showSlideCount = 1, showPrevBtn = 1, showNextBtn = 1 }) => {
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [isPause, setIsPause] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [preventClick, setPreventClick] = useState(false);
  const [slideCount, setSlideCount] = useState(0);
  const slideCount1 = banners.length;

  // Auto-slide
  useEffect(() => {
    const slideInterval = setInterval(() => {
      let _slideCount = banners.length;
      setSlideCount(_slideCount);
      if (_slideCount > 1 && !isPause) nextSlide();
    }, interval);

    return () => clearInterval(slideInterval);
  }, [current, slideCount, banners, interval, isPause]);

  const prevSlide = () => {
    setIsTransitioning(true);
    let currentVar = (current - 1 + slideCount1) % slideCount1;
    setCurrent(Number.isNaN(currentVar) ? slideCount1 - 1 : currentVar);
  };

  const nextSlide = () => {
    setIsTransitioning(true);
    let currentVar = (current + 1) % slideCount1;
    setCurrent(Number.isNaN(currentVar) ? 1 : currentVar);
  };

  // Drag / Swipe handlers
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setIsTransitioning(false);
    setStartX(e.touches[0].clientX);
    setPreventClick(false);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientX - startX;
    if (Math.abs(diff) > 5) setPreventClick(true);
    setTranslateX(diff);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    setIsTransitioning(true);

    if (translateX > 50) {
      prevSlide();
    } else if (translateX < -50) {
      nextSlide();
    }

    setTranslateX(0);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setIsTransitioning(false);
    setStartX(e.clientX);
    setPreventClick(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 5) setPreventClick(true);
    setTranslateX(diff);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setIsTransitioning(true);

    if (translateX > 50) {
      prevSlide();
    } else if (translateX < -50) {
      nextSlide();
    }

    setTranslateX(0);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // hoặc 'auto'
    });
  };

  return (
    <div
      className={className}
      style={{ position: 'relative', overflow: 'hidden' }}
      ref={sliderRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseMove={(e) => {
        handleMouseMove(e);
        setIsPause(true);
      }}
      onMouseLeave={(e) => {
        if (isDragging) handleMouseUp(e);
        setIsPause(false);
      }}
    >
      {/* Hiển thị số thứ tự slide */}
      <div
        className='slide-count'
        style={{
          position: 'absolute',
          top: 10,
          left: 10,
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          padding: '2px 8px',
          borderRadius: 6,
          fontSize: 14,
          zIndex: 2,
          display: showSlideCount === 1 ? 'block' : 'none',
        }}
      >
        {current + 1}/{slideCount1}
      </div>

      {/* Slider track */}
      <div
        className="slider-track"
        style={{
          display: 'flex',
          transition: isTransitioning ? 'transform 0.4s ease' : 'none',
          transform: `translateX(calc(-${current * 100}% + ${translateX}px))`,
        }}
      >
        {banners.map((banner, index) => (
          <Link
            to={banner.url}
            key={index}
            onClick={(e) => {
              if (preventClick) {
                e.preventDefault();
              } else {
                scrollToTop();
              }
            }}
            onMouseEnter={e => e.currentTarget.style.border = "1px solid #37A1FF"} 
            onMouseLeave={e => e.currentTarget.style.border = "1px solid #ddd"}
            style={{ minWidth: '100%', width: '100%', display: "block", alignItems: "center", gap: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "5px", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", background: "#fff", textDecoration: "none", color: "inherit" }}
            className="slider-item baiviet-item simvip"
          >
            <img src={banner.image ? banner.image : ''} alt={banner.title ? banner.title : ''}  style={{ width: "100%", height: "auto", marginBottom: 10 }} />
            <div style={{width: "100%"}} draggable={false}>
              <div className="title">{banner.title}</div>
              <div className="date d-none">{moment(banner.createdAt).format('DD-MM-YYYY')}</div>
              <div className="short-description">{banner.short_description}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Nút điều hướng */}
      <button
        onClick={prevSlide}
        style={{
          position: 'absolute',
          top: '50%',
          left: 10,
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: 30,
          height: 30,
          fontSize: 18,
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          opacity: 0.5,
          display: showPrevBtn === 1 ? 'flex' : 'none',
        }}
      >
        &lt;
      </button>

      <button
        onClick={nextSlide}
        style={{
          position: 'absolute',
          top: '50%',
          right: 10,
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: 30,
          height: 30,
          fontSize: 18,
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          opacity: 0.5,
          display: showNextBtn === 1 ? 'flex' : 'none',
        }}
      >
        &gt;
      </button>
    </div>
  );
};

export default CustomSlider1;
